export interface IUploadDropzone {
  onChange: any
  iconAndText?: React.ReactNode
  acceptType?: uploadInputZones
  mainColor?: string
}

export enum uploadInputZones {
  TEXT_FIELD = 'TEXT_FIELD',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT',
  LINK = 'LINK',
  ALL = 'ALL',
}
